import React, { useState, useEffect } from 'react';
import { api } from '../api';
import './Modal.css';

export default function ComposeModal({ domain, onClose, onSaved }) {
  const [compose, setCompose] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.getCompose(domain)
      .then(d => setCompose(d.compose))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [domain]);

  async function handleSave() {
    setSaving(true);
    setError('');
    try {
      await api.updateCompose(domain, compose);
      onSaved();
    } catch (e) {
      setError(e.message);
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal modal-wide">
        <div className="modal-header">
          <h2>✎ Edit Compose — {domain}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="center"><div className="spinner" /></div>
          ) : (
            <textarea
              className="compose-preview"
              value={compose}
              onChange={e => setCompose(e.target.value)}
              rows={28}
              spellCheck={false}
              autoFocus
            />
          )}
          {error && <div className="modal-error">{error}</div>}
          <div className="modal-footer-note">
            ⚠ After saving, restart the site from the dashboard to apply changes.
          </div>
          <div className="modal-footer">
            <button className="btn-ghost" onClick={onClose}>Cancel</button>
            <button className="btn-primary" onClick={handleSave} disabled={saving || loading}>
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
